import React from 'react';
import { SEOHead } from '../components/SEOHead';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { TrustBar } from '../components/TrustBar';
import { TrustBadges } from '../components/TrustBadges';
import { SocialProofBar } from '../components/SocialProofBar';
import { BenefitsSection } from '../components/BenefitsSection';
import { AboutSection } from '../components/AboutSection';
import { ProcessSection } from '../components/ProcessSection';
import { GeoSection } from '../components/GeoSection';
import { VehicleTypesSection } from '../components/VehicleTypesSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { AccidentGuideSection } from '../components/AccidentGuideSection';
import { ReviewsSection } from '../components/ReviewsSection';
import GoogleReviews from '../components/GoogleReviews';
import { PartnerTeaserSection } from '../components/PartnerTeaserSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { MobileStickyCTA } from '../components/MobileStickyCTA';
import { StickyWhatsAppButton } from '../components/StickyWhatsAppButton';

// Video Component inline
const VideoShowcase = () => (
  <section className="py-16 bg-gradient-to-br from-gray-900 to-black">
    <div className="max-w-6xl mx-auto px-6">
      <div className="text-center mb-8">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          So läuft die Begutachtung ab
        </h2>
        <p className="text-xl text-gray-300">
          Professionelle Schadensdokumentation direkt vor Ort
        </p>
      </div>
      <div className="rounded-2xl overflow-hidden shadow-2xl">
        <video 
          controls 
          autoPlay 
          muted 
          loop
          className="w-full"
          poster="/videos/unfallgutachten-prozess-poster.jpg"
        >
          <source src="/videos/unfallgutachten-prozess.mp4" type="video/mp4" />
          Ihr Browser unterstützt kein Video.
        </video>
      </div>
    </div>
  </section>
);

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead />
      <Header />
      <main>
        <HeroSection />
        <TrustBadges />
        <SocialProofBar />
        <TrustBar />
        <BenefitsSection />
        <AboutSection />
        <VideoShowcase />
        <ProcessSection />
        <TestimonialsSection />
        <GeoSection />
        <VehicleTypesSection />
        <AccidentGuideSection />
        
        {/* Echte Google Bewertungen */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-3">
              <p className="text-brand-green font-semibold mb-2">Kundenbewertungen</p>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Das sagen unsere Kunden
              </h2>
              <p className="text-lg text-gray-600">
                Überzeugen Sie sich von der Qualität unserer Arbeit
              </p>
            </div>
            <GoogleReviews />
          </div>
        </section>
        
        <PartnerTeaserSection />
        <FAQSection />
      </main>
      <Footer />
      <MobileStickyCTA />
      <StickyWhatsAppButton />
    </div>
  );
};

export default Home;